import React from 'react';
import PropTypes from 'prop-types';

import styles from './ResizablePanels.scss';

class ResizablePanels extends React.Component {
  eventHandler = null;

  constructor() {
    super();

    this.panelRef = React.createRef();
    this.state = {
      isDragging: false,
      panelSizes: [0, 0],
    };
  }

  componentDidMount() {
    this.panelRef.current.addEventListener('mousemove', this.resizePanel);
    this.panelRef.current.addEventListener('mouseup', this.stopResize);
    this.panelRef.current.addEventListener('mouseleave', this.stopResize);

    // 0.75 stands for 75% of the screen
    // 0.25 stands for 25% of the screen
    const heightOfFirst = this.panelRef.current.clientHeight * 0.75;
    const heightOfSecond = this.panelRef.current.clientHeight * 0.25;
    this.setState({
      panelSizes: [heightOfFirst, heightOfSecond],
    });
  }

  render() {
    return (
      <div
        ref={this.panelRef}
        className={`${styles.panelContainer}`}
        onMouseUp={() => this.stopResize()}
      >
        {this.props.children.map((child, i) => {
          let childRender;
          if (i === 0) {
            childRender = this.props.children[0](this.state.panelSizes[0]);
          } else {
            childRender = child(this.state.panelSizes[i]);
          }

          return (
            <React.Fragment>
              {childRender}
              {this.props.children.length - i === i ? null : (
                <div
                  onMouseDown={e => this.startResize(e, i + 1)}
                  key={`resizer_${i}`}
                  style={
                    this.state.currentPanel === i + 1
                      ? { top: this.state.delta }
                      : {}
                  }
                  className={`${styles.resizer}`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  animateConsole = () => {
    if (this.panelRef.current) {
      const totalHeight = this.panelRef.current.clientHeight;
      const recommendedUp = totalHeight * 0.6;
      if (!(this.state.panelSizes[0] < recommendedUp)) {
        this.panelRef.current.style.transition = '.4s all ease-in-out';

        this.setState(
          {
            panelSizes: [recommendedUp, totalHeight - recommendedUp],
          },
          () => {
            setTimeout(() => {
              /**
               * Calling setState here is a @HACK
               * Because of some internal bug of REACT-ACE, on changing the height above, the editor component
               * is not rerendering, as a result, some of the code at the bottom gets cut out
               * so we're setting state again with changed heights
               * which causes REACT-ACE to rerender (2nd time)
               */
              this.setState(({ panelSizes }) => ({
                panelSizes: [panelSizes[0] - 1, panelSizes[1] + 1],
              }));
              this.panelRef.current.style.transition = 'none';
            }, 600);
          }
        );
      }
    }
  };

  startResize = (event, index) => {
    this.setState({
      isDragging: true,
      currentPanel: index,
      initialPos: event.clientY,
    });
  };

  stopResize = () => {
    if (this.state.isDragging) {
      this.setState(({ panelSizes, delta }) => ({
        isDragging: false,
        panelSizes: [panelSizes[0] + delta, panelSizes[1] - delta],
        delta: 0,
        currentPanel: null,
      }));
    }
  };

  resizePanel = event => {
    if (this.state.isDragging) {
      this.setState(prevState => ({
        ...prevState,
        delta: event.clientY - prevState.initialPos,
      }));
    }
  };
}

ResizablePanels.propTypes = {
  children: PropTypes.arrayOf(PropTypes.func),
};

ResizablePanels.defaultProps = {
  children: [],
};

export default ResizablePanels;
